import z from 'zod'
import {
  firestoreWriteTimestamp,
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalString,
  nullSafeOptionalStringArray,
  nullSafeString,
} from '../shared/schema'
import { RubricType } from '../../types'

const rubricTypeSchema = z.nativeEnum(RubricType)

export const schema = z.object({
  rubric: nullSafeString(''),
  rubricDescription: nullSafeString(''),
  rubricPrompt: nullSafeString(''),
  // failing on fake AI
  rubricType: z.preprocess((val) => val ?? RubricType.blooms, rubricTypeSchema),
  rubricLabel0: nullSafeOptionalString('Did Not Discuss'),
  rubricLabel1: nullSafeOptionalString('Discussed'),
  // I'd like to use these arrays instead of the labels above and make it more generic
  // the the UI if you want to set these values, you should have to set all the possible values
  // for valid scores
  rubricScoreCustomExplanation: nullSafeOptionalStringArray([]),
  rubricScoreCustomMeaning: nullSafeOptionalStringArray([]),
  rubricScoreCustomTitle: nullSafeOptionalStringArray([]),
  startSlideId: nullSafeOptionalString(),
  /** acts and end slide if startSlideId is present */
  slideId: nullSafeOptionalString(),
  assignmentRoles: nullSafeOptionalStringArray([]),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
})

export const empty = Object.freeze(
  schema.parse({
    rubric: '',
    rubricDescription: '',
    rubricPrompt: '',
    rubricType: RubricType.blooms,
  })
)

export const writeSchema = schema.extend({
  updatedAt: firestoreWriteTimestamp,
})

export type FirestoreSlideRubric = z.infer<typeof schema>
